<template>
    <div id="app">
        <!-- 头部 -->
        <app-header></app-header>

        <div class="content">
            <router-view ></router-view>
        </div>

        <app-footer></app-footer>
    </div>
</template>

<script>
import AppHeader from "./components/Header";
import AppFooter from "./components/Footer";
import initAimation from "./Pages/animation"
export default {
    name: "App",
    data() {
        return {};
    },
    mounted(){
        setTimeout(initAimation,0)
    },
    components: {
        AppHeader,
        AppFooter,

    },
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 0;
    padding: 0;
}
.content {
    padding-top: 60px;
    background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue